import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { ConsultaConvenioService } from 'src/app/services/consulta-convenio/consulta-convenio.service';
import { ConsultaPostulacionesService } from 'src/app/services/consulta-postulaciones/consulta-postulaciones.service';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';
import { DialogEditConvenio } from '../convenio/convenio-validar-codeudor.component';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { DialogEditConvenioEjecutivo } from '../convenio/convenio-validar-ejecutivo.component';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-consulta-convenio',
  templateUrl: '../../pages/consulta-convenio/consulta-convenio.component.html',
  styleUrls: ['../../pages/consulta-convenio/consulta-convenio.component.css']
})
export class ConsultaConvenioComponent implements OnInit 
{
    cuotas:any
    postulacionesFinales: any
    postulacionSeleccionada: any
    allComplete: boolean = false
    idUsuario: string= localStorage.getItem("idUsuario");
    postulaciones: any
    postulacion:any
    rol: string = localStorage.getItem("rol")
   // config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5 }
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, paginasTotal: 5 }
  
    tipoPostulacion : string = "Disponibles"
    tiposBeca: any = []
    idEjecutivo = localStorage.getItem("idUsuario")
    solicitud = "convenio";
    estado:any
    recarga: boolean = false
    regiones:any
    proveedores: any
    totalMaximo: any
    categorias: any
    buscador: any =
    {
        rut:'', region:'0', fechaInicio:'', fechaFin:'', itemsPerPage: 5, currentPage:1, idSolicitud:'',
       // estado:['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA'],
        estado:['INGRESADA'],
        paginasTotal:5, estadoselect:[ 'INGRESADA']
    }

    constructor(public router: Router, public consultaConvenioService:ConsultaConvenioService,public consultaPostulacionesService:ConsultaPostulacionesService, 
                private dialog: MatDialog, private tiposService: TiposService) { }

    ngOnInit(): void 
    {
        if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
            this.consultaConvenioService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))
            this.consultaConvenioService.traeEstados().then(estado=> this.estado = estado).catch(error => console.log(error))
            this.postulacionesDisponiblesBuscador(true);
           
        }else{
            this.postulacionesDisponibles();
        }
        
        
    }

    postulacionesDisponibles()
    {
        let vm = this
        vm.tipoPostulacion = "Disponibles"
        vm.solicitud ='convenio'


        this.consultaConvenioService.traePostulacionesDisponiblesPorIdUsuario(localStorage.getItem("idUsuario"),localStorage.getItem("rol")).
        then
        (
            (postulaciones: any) =>
            {
                vm.postulaciones = postulaciones
                
                vm.config.currentPage = 1
                vm.config.totalItems = vm.postulaciones.length
            }
        )
        .catch ( error =>
        {
            console.log(error)

            vm.postulaciones = []            
            vm.config.totalItems = 0
            
            if(error.status == 404) vm.openAlertDialog("No se han encontrado postulaciones disponibles.", "btn-dark")           
        } )
    }
    postulacionesDisponiblesBuscador(recarga?:boolean){
        
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        
        vm.tipoPostulacion = "Disponibles"
        vm.solicitud ='convenio'
       
        if(recarga) {
          vm.config.currentPage = 1, vm.buscador.currentPage = 1
          this.buscador.region = '0';
          //this.buscador.estadoselect= ['INGRESADA'];
          this.buscador.estadoselect= ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA'];
          this.buscador.rut ='';
          this.buscador.fechaInicio='';
          this.buscador.fechaFin='';
          this.buscador.idSolicitud='';

        }
   
        this.buscador.region=this.buscador.region
        this.buscador.estado=this.buscador.estadoselect;
  
          vm.consultaConvenioService.postulacionesDisponiblesBuscador(this.idUsuario,this.rol,this.buscador,localStorage.getItem("username")).then(
            (postulaciones : any)=>
             {
                postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })

                vm.postulaciones = postulaciones.resultado
                vm.buscador.paginasTotal = postulaciones.resultado.length
                vm.config.currentPage = this.buscador.currentPage
                vm.config.totalItems = postulaciones.cantidadRegistros

                          
                vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                this.buscador.paginasTotal = postulaciones.cantidadPaginas
                if (this.buscador.currentPage < postulaciones.cantidadPaginas) {
                  this.config.itemsPerPage = postulaciones.resultado.length
                }

                Swal.close();
               }
             )
           .catch ( error =>
           {
            console.log(error)
            
                       
            vm.config.currentPage = 1
            vm.postulaciones = []            
            vm.config.totalItems = 0
               this.openAlertDialog('No se pudo obtener las postulaciones de convenio disponibles.', 'btn-danger')
               Swal.close();
           } )
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, 
        {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
        } )
    }

    updateAllComplete()
    {
        this.allComplete =  this.postulacion != null && this.postulacion
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }
    pageChanged(event: any) {
        this.config.currentPage = event 
        this.buscador.currentPage = event
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
        if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
          
            this.postulacionesDisponiblesBuscador(false);
           
        }else{

            if(event==1){
                this.postulacionesDisponibles();
            }
         
        }
        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    
     }


    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }

    cargaSolicitudesCodeudor(){
        let vm = this;
        vm.postulaciones = [] 
        vm.tipoPostulacion = "Disponibles"
        vm.solicitud ='codeudor'
        vm.consultaConvenioService.postulacionesCodeudor(this.idUsuario,this.buscador).then(
            (prestamos : any)=>
             {
               vm.postulaciones = prestamos.resultado
               console.log("respuesta ",prestamos);
               console.log("postulaciones", vm.postulaciones);
               vm.config.currentPage = 1
               vm.config.totalItems = prestamos.length
               vm.tipoPostulacion = "Codeudor"
               
               }
             )
           .catch ( error =>
           {
               console.log(error)
               Swal.close();
                          
                vm.config.currentPage = 1
                vm.postulaciones = []            
                vm.config.totalItems = 0
               this.openAlertDialog('No se pudo obtener las solicitudes de codeudor.', 'btn-danger')
           } )
    

    }
    openDialogCodeudorConvenio(prestamoId:any, editable:any){
        
        this.consultaConvenioService.traeConvenio(prestamoId).then(
            (response : any)=>{
                let data: any =
                {   
                    idConvenio: response.idConvenio,
                    idPostulacion : response.idPostulacion,
                    nombreUsuario : response.nombreUsuario,
                    apellidoUsuario : response.apellidoUsuario,
                    idCodeudor : this.idUsuario,
                    rutUsuario: response.rutUsuario,
                    cantidadCuota : response.cantidadCuota,
                    idCantidadCuota: response.idCantidadCuota,
                    montoCuota: response.totalCuota,
                    fechaIngreso:response.fechaIngreso,
                    fechaPrimerPago :response.fechaPrimerPago,
                    montoSolicitado:response.montoSolicitado,
                    tipoPrestamo: response.tipoPrestamo,
                    nombreCorto: response.nombreCorto, 
                    region: response.idRegion,
                    idCarga: response.idCarga,
                    nombreCarga: response.nombreCarga,
                    rutCarga: response.rutCarga,
                    numPresupuesto: response.numPresupuesto,
                    idProveedor: response.idProveedor,
                    editable: editable,
                    descripcionCantidadCuotas: response.descripcionCantidadCuotas
                }
                this.consultaConvenioService.traeProveedoresPorId(data.idProveedor).then (salida =>
                    data.proveedor = salida).catch(error =>{ console.log(error);  });
                this.consultaConvenioService.traeRegiones().then(regiones => data.regiones = regiones).catch(error => console.log(error));
       
    
                
                let vm =this;
          
                const dialogRef = vm.dialog.open(DialogEditConvenio,
                     { width: '40%', data: data} )
                     Swal.close();
                dialogRef.afterClosed().subscribe( () => 
                { 
                    this.consultaConvenioService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))
                    this.consultaConvenioService.traeEstados().then(estado=> this.estado = estado).catch(error => console.log(error))
                    //this.postulacionesDisponiblesBuscador(true);
                   // this.postulacionesAsignadas();

                    if(data.recarga){
                        setTimeout(function(){
                          console.log("recarga consulta:",data.recarga)
                          vm.postulacionesAsignadas(true)
                        },3000);
                    }
                      Swal.close();
                })
                
                
            }
        )
            .catch ( error =>
                {
                    console.log(error)
                    Swal.close();
                    this.openAlertDialog('No se pudo obtener la postulacion.', 'btn-danger')
                } )
        

    }
    postulacionesAsignadas(recarga?:boolean)
    {
        let vm = this
        this.solicitud ='convenio'
        this.buscador.estadoselect=[];
        if(recarga){
            vm.tipoPostulacion = "Asignadas"
            this.buscador.estadoselect=['EN VALIDACION',  'RECHAZADA', 'APROBADA'];
        }
        this.buscador.estado=this.buscador.estadoselect;
       
        this.consultaConvenioService.traePostulacionesAsignadas(localStorage.getItem("idUsuario"),this.buscador).then
        (
            (postulaciones: any) =>
            {
                vm.postulaciones = postulaciones.resultado
                
                vm.config.currentPage = 1
                vm.config.totalItems = vm.postulaciones.length
            }
        )
        .catch ( error => 
        { 
            console.log(error)

            vm.postulaciones = []            
            vm.config.totalItems = 0
        } )
    }

    
    verArchivo(postulacionId: any)
    {
        let vm = this

        this.consultaConvenioService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {
                console.log(archivos)
                
                const byteCharacters = atob(archivos[0].archivo.split(',')[1])
                const byteNumbers = new Array(byteCharacters.length)
                
                for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i) }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: archivos[0].extension});
                
                var fileURL = URL.createObjectURL(blob)
                window.open(fileURL)
            }
        )
        .catch ( error =>  
        {
            console.log(error)

            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        } )        
    }


    onDescargarArchivosClick(postulacionId: any)
        {
            let vm = this
     
            this.consultaConvenioService.traeArchivos(postulacionId).then
            (
                (archivos: any) =>
                {                
                    archivos.forEach( archivo => {
                        var fileURL=`${environment.urlBlob}/${archivo.url}`    
                        window.open(fileURL,'_blank')                     
                    })  
                   
                }
            )
            .catch
            (
                error =>
                {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
        }

    asignaPostulacion(idPostulacion: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let postulacion = [{id:idPostulacion}]
        let vm = this

        this.consultaConvenioService.asignaPostulacion(postulacion, this.idEjecutivo).then
        (
            () =>
            {
              if (vm.buscador.paginasTotal == 1 && vm.buscador.currentPage>1){

                vm.buscador.currentPage = vm.buscador.currentPage-1;
                  vm.config.currentPage = this.buscador.currentPage
              }
                vm.openAlertDialog('La solicitud de convenio se ha asignado exitosamente.', 'btn-success')
                setTimeout(function(){
                  vm.postulacionesDisponiblesBuscador(false)
                },500);
                Swal.close();
            }
        )
        .catch
        (
            error =>
            {
                Swal.close();
                console.log(error)
                vm.openAlertDialog('La solicitud de convenio no se ha podido asignar.', 'btn-danger')
            }
        )
    }
    asignarSeleccionados()
    {
        let postulacionesSeleccionadas: any = []

        this.postulacion.filter( pos => pos.seleccionado ).forEach(pos => {
            postulacionesSeleccionadas.push({id:pos.idPostulacion })
        })

        let vm = this

        if(postulacionesSeleccionadas.length == 0)
        {
            this.openAlertDialog("Debe seleccionar al menos un pago.", "btn-danger")
            return
        }
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();

        this.consultaConvenioService.asignaPostulacion(postulacionesSeleccionadas, this.idEjecutivo).then
        (
            () =>
            {
              if (vm.buscador.paginasTotal == postulacionesSeleccionadas.length && vm.buscador.currentPage>1){

                vm.buscador.currentPage = vm.buscador.currentPage-1;
                vm.config.currentPage = this.buscador.currentPage
              }

                vm.openAlertDialog('La solicitudes de convenio se ha asignado exitosamente.', 'btn-success')

                  vm.postulacionesDisponiblesBuscador()


                  Swal.close();
            }
        )
        .catch ( error =>
        {
            Swal.close();
            console.log(error)
            vm.openAlertDialog('Las solicitudes de convenio no se ha podido asignar.', 'btn-danger')
        } )
    }  
    someComplete(): boolean
    {
        if (isNullOrUndefined(this.postulaciones?.seleccionado)) { return false }

        return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
    } 
    setAll(seleccionado: boolean)
    {
        this.allComplete = seleccionado

        if (this.postulaciones == null) { return }

        this.postulaciones.forEach(pos => { pos.seleccionado = seleccionado })
    }
    openEditDialogValidarConvenio(idConvenio:any,mostrarEditar?: any, disponiblePago?: any){
       
        this.consultaConvenioService.traeCategoriaConvenio().then(response =>  this.categorias = response).catch(error => console.log(error))
        this.consultaConvenioService.traeProveedorSelect().then(response => this.proveedores = response).catch(error => console.log(error))
        this.consultaConvenioService.traeCantidadCuotas().then(cuota =>this.cuotas = cuota).catch(error => console.log(error))
        this.consultaConvenioService.traeRegionesEspeciales().then(regiones => this.regiones = regiones).catch(error => console.log(error))
        this.consultaConvenioService.traeMontoTotalDisponible(this.idEjecutivo).then(response => this.totalMaximo=response).catch(error =>{console.log(error); this.totalMaximo = 0;   });
        let vm = this
        let data: any = {}
        this.consultaConvenioService.traeConvenio(idConvenio).then(
            (response : any)=>{
                
                
                { 
                   
                    data.regiones = this.regiones,
                    data.categorias = this.categorias,
                    data.totalMaximo = this.totalMaximo,
                    data.proveedores = this.proveedores,
                    data.idCodeudor = this.idUsuario,
                    data.montoSolicitado = response.montoSolicitado,
                    data.idConvenio =  response.idConvenio,
                    data.idPostulacion = response.idPostulacion,
                    data.nombreUsuario = response.nombreUsuario,
                    data.rutUsuario = response.rutUsuario,
                    data.idCantidadCuota = response.idCantidadCuota,
                    data.montoCuota = response.montoCuota,
                    data.fechaIngreso = response.fechaIngreso,
                    data.fechaPrimerPago = response.fechaPrimerPago,
                    data.idTipoConvenio = response.idTipoConvenio,
                    data.idRegion = response.idRegion,
                    data.nombreCodeudorUno = response.nombreCodeudorUno,
                    data.nombreCodeudorDos = response.nombreCodeudorDos,
                    data.rutCodeudorUno = response.rutCodeudorUno,
                    data.rutCodeudorDos = response.rutCodeudorDos,
                    data.idProveedor = response.idProveedor,
                    data.idProducto = response.idProducto ,
                    data.idCarga = response.idCarga,
                    data.nombreCarga = response.nombreCarga,
                    data.rutCarga = response.rutCarga,
                    data.numPresupuesto = response.numPresupuesto,
                    data.mostrarEditar = mostrarEditar,
                    data.disponiblePago = disponiblePago,
                    data.idAfiliado = response.idUsuario,
                    data.tieneConvenioAdjunto = response.tieneConvenioAdjunto,
                    this.consultaConvenioService.traeCantidadCuotasProveedor(response.idProveedor).
                    then(cuota =>data.cuotas = cuota).catch(error => console.log(error))
                    //cuotas: this.cuotas            
                }
               // let vm =this;
               
                const dialogRef = vm.dialog.open(DialogEditConvenioEjecutivo,
                     { width: '40%', data: data} )
                     Swal.close();
                dialogRef.afterClosed().subscribe( () => {
                    if(this.rol=='ROLE_AFILIADO'){
                        if (this.tipoPostulacion == 'Codeudor') {
                            this.cargaSolicitudesCodeudor()
                        }else{
                            this.postulacionesDisponibles()
                        }                      
                    }else{
                        if (this.tipoPostulacion == 'Disponibles') {
                            this.postulacionesDisponiblesBuscador(false)
                        } else {
                            this.postulacionesAsignadas(false)
                        }
                    }                   
                    
                } )
            }
        )
            .catch ( error =>
                {
                    console.log(error)
                    Swal.close();
                    this.openAlertDialog('No se pudo obtener la postulacion.', 'btn-danger')
                } )
                
    }
  
    detalleBeneficiario(rutAfiliado: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let data: any = { }

        this.consultaConvenioService.traeUsuario(rutAfiliado.split('-')[0]).then
        (
            (usu: any) =>
            {
                console.log(usu)

                data.nombre = usu.nombres + ' ' + usu.apellidoPaterno + ' ' + usu.apellidoMaterno
                data.telefono = usu.telefonoFijo
                data.celular = usu.telefonoMovil
                data.mail = usu.email
                data.prevision = usu.prevision
                data.beneficiarios = usu.carga
            }
        )
        .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe( () => {  })
    }

  
    detalleRechazoBeneficiario(idPostulacion: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let data: any = { }

        this.consultaPostulacionesService.traeDataRechazo(idPostulacion).then
        (
            (postulacion: any) =>
            {
              
                data.tipoRechazo=postulacion.motivoRechazo
                data.comentarioRechazo=postulacion.descripcionRechazo
             
            }
        )
        .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe( () => {  })
    }

    buscar(){
     
        let vm = this
        this.solicitud ='convenio'
        let rolUsuario = localStorage.getItem("rol");
        let idUsuario=localStorage.getItem("idUsuario");
        this.buscador.estado=this.buscador.estadoselect;
       
        /*if(rolUsuario ="ROLE_AFILIADO"){
            idUsuario ="";
        }*/
        vm.consultaConvenioService.buscaPostulacionesPorFiltro(idUsuario,this.buscador).then(
            (postulaciones : any)=>
            {
               postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })               
               vm.postulaciones = postulaciones.resultado
               vm.buscador.paginasTotal = postulaciones.resultado.length
               vm.config.totalItems = postulaciones.cantidadRegistros
               this.buscador.paginasTotal= postulaciones.cantidadPaginas
               vm.config.currentPage = this.buscador.currentPage
               vm.config.totalItems = postulaciones.cantidadRegistros

               if (this.buscador.currentPage < postulaciones.cantidadPaginas) {
                 this.config.itemsPerPage = postulaciones.resultado.length
               }

               Swal.close();
              }
            )
          .catch ( error =>
          {
           console.log(error)   
           vm.config.currentPage = 1
           vm.postulaciones = []            
           vm.config.totalItems = 0
              this.openAlertDialog('No se pudo obtener resultados.', 'btn-danger')
              Swal.close();
          } )
    }
    openDialogAnular(idPostulacion: any, rut: any)
    {
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de anular la solicitud de Préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe( (confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                let vm = this
            
                this.consultaConvenioService.cambiarEstadoPostulacion(idPostulacion, "ANULADA").then
                (
                    () =>
                    {   
                        this.postulacionesDisponibles();                 
                        vm.openAlertDialog('La postulación se ha anulado exitosamente!', 'btn-success')
                        Swal.close();
                    }
                )
                .catch
                (
                    error =>
                    {

                        Swal.close();
                        console.log(error)
                        vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
                    }
                )

            }
        })
    }
}